module.exports = __webpack_public_path__ + "static/media/appointment_slider_phone2.aab23229.png";